import React from "react";

const TermsIcon = () => {
	return (
		<svg
			width="14"
			height="15"
			viewBox="0 0 14 15"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<title>Terms</title>
			<path
				d="M0.589382 13.2083H8.08397C8.23758 13.2083 8.36723 13.2598 8.47292 13.3627C8.57876 13.4655 8.63167 13.5931 8.63167 13.7456C8.63167 13.8981 8.57987 14.0272 8.47626 14.1329C8.37265 14.2387 8.24403 14.2917 8.09042 14.2917H0.596048C0.442437 14.2917 0.312715 14.2402 0.206882 14.1373C0.101187 14.0345 0.0483398 13.9069 0.0483398 13.7544C0.0483398 13.6019 0.100146 13.4728 0.203757 13.3671C0.307229 13.2612 0.43577 13.2083 0.589382 13.2083ZM3.48771 9.03687L1.41167 6.97583C1.15445 6.72056 1.02584 6.40861 1.02584 6.04C1.02584 5.67139 1.15563 5.35465 1.41522 5.08979L1.9473 4.54979L5.88792 8.51125L5.36876 9.03042C5.10917 9.29 4.79508 9.41979 4.42647 9.41979C4.05785 9.41979 3.74494 9.29215 3.48771 9.03687ZM9.01147 5.38771L5.07084 1.44708L5.59001 0.935832C5.85487 0.676249 6.1716 0.542985 6.54022 0.53604C6.90883 0.529096 7.22174 0.654235 7.47896 0.911458L9.55501 2.9875C9.81223 3.24472 9.93737 3.55764 9.93042 3.92625C9.92348 4.29486 9.79022 4.60896 9.53063 4.86854L9.01147 5.38771ZM12.561 12.8142L3.10126 3.375L3.87522 2.60104L13.3352 12.0608C13.4505 12.1762 13.5095 12.3005 13.5123 12.4335C13.5149 12.5665 13.4559 12.6933 13.3352 12.8142C13.2144 12.9349 13.0854 12.9952 12.9481 12.9952C12.8109 12.9952 12.6819 12.9349 12.561 12.8142Z"
				fill="#5663F2"
			/>
		</svg>
	);
};

export default TermsIcon;
